import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SnackbarListComponent } from 'src/app/components/snackbar-list/snackbar-list.component';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    constructor(private snackBar: MatSnackBar) {
    }

    openSnackBar(message: string, isError?: boolean) {
        this.snackBar.open(message, ' ', {
            duration: 6000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: [`snackbar${isError ? 'Error' : ''}`]
        });
    }

    openListSnackBar(message: string, list: string[], isError?: boolean) {
        this.snackBar.openFromComponent(SnackbarListComponent, {
            data: {message: message, list: list},
            duration: 6000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: [`snackbar${isError ? 'Error' : ''}`]
        });
    }

    dismiss() {
        this.snackBar.dismiss();
    }
}
